import React, {Component, Fragment} from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import TicketSoldList from './TicketSoldList';
import { Link } from 'react-router-dom';

let permisionActions = [];
class TicketSolds extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.ticketSoldState.pageSize,
                pageIndex: this.props.ticketSoldState.pageIndex,
                ticketCode: !!this.props.match.params.ticket ? (this.props.match.params.ticket.split('...'))[0] : '' ,
                skuCode: !!this.props.match.params.ticket && !!this.props.match.params.ticket.includes('...') ? (this.props.match.params.ticket.split('...'))[1] : '' 
            }
        }
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TICKET_SOLD);
        this.props.getListTicketSold(this.state.filters);
    }

    render() {
        const { t, ticketSoldState } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, ticketSolds } = ticketSoldState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'ticketSold'}
                        titleHeader={t('navigation.ticketSold')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.OBJECT_TYPES.CREATE.path}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <TicketSoldList loading={isFetching}
                                  permisions={permisionActions}
                                  ticketSolds={ticketSolds}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDeleteTicketSold}
                                  defaultCodeFilter={this.state.filters.ticketCode}
                                  defaultTourCodeFilter={this.state.filters.skuCode}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onChangeLanguage = () => {
        this.props.getListTicketSold(this.state.filters)
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListTicketSold(newFilters);
    }

    onDeleteTicketSold = (item) => {
        // this.props.deleteTicketSoldDetail(item, {
        //     filters: {
        //         pageSize: this.props.ticketSoldState.pageSize,
        //         pageIndex: this.props.ticketSoldState.pageIndex
        //     }
        // });
    }
}

export default TicketSolds
